<template>
  <div class="provider-applications-closed">
    <h2 class="text-h4 mb-8">No Closed Jobs</h2>
    <p class="text-body">Jobs you've applied for that have closed will appear here</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProviderApplicationsClosed',
});
</script>
